var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChlorophyll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0C12.5878 0.00274688 10.9651 0.507081 9.59416 1.44704C8.22323 2.387 7.16789 3.71882 6.56617 5.2683C6.08413 4.56903 5.43949 3.99727 4.68767 3.60216C3.93584 3.20705 3.09932 3.00041 2.25 3H0V5.25C0.0015484 6.64191 0.555169 7.97637 1.5394 8.9606C2.52363 9.94483 3.85809 10.4985 5.25 10.5H6V17.287C4.2773 17.4554 2.66718 18.2191 1.44675 19.4465L2.50725 20.5071C3.13464 19.8798 3.89333 19.3995 4.72869 19.1006C5.56405 18.8018 6.45528 18.692 7.33819 18.779C8.2211 18.8661 9.07373 19.1478 9.83465 19.604C10.5956 20.0602 11.2459 20.6794 11.7387 21.4172L12.9849 20.5826C12.3701 19.6638 11.5593 18.8926 10.611 18.3244C9.66262 17.7562 8.60018 17.4052 7.5 17.2965V10.5H8.25C10.4373 10.4975 12.5343 9.62753 14.0809 8.08089C15.6275 6.53425 16.4975 4.43727 16.5 2.25V0H14.25ZM5.25 9C4.25579 8.99887 3.30262 8.60342 2.5996 7.9004C1.89658 7.19738 1.50113 6.24421 1.5 5.25V4.5H2.25C3.24423 4.50107 4.19744 4.8965 4.90047 5.59953C5.6035 6.30256 5.99893 7.25577 6 8.25V9H5.25ZM15 2.25C14.998 4.0396 14.2862 5.75534 13.0208 7.02078C11.7553 8.28622 10.0396 8.99801 8.25 9H7.5V8.25C7.50199 6.4604 8.21378 4.74466 9.47922 3.47922C10.7447 2.21378 12.4604 1.50199 14.25 1.5H15V2.25Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChlorophyll);
export default __webpack_public_path__ + "static/media/chlorophyll.db202756.svg";
export { ForwardRef as ReactComponent };